import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext, ModalContext } from '../../../components/contexts';
import ExpertConsultController from '../../../controllers/expert/consult/ExpertConsultController';
import ValidateService from '../../../services/ValidateService';

import GbitGrid from '../../../components/gridComponents/GbitGrid';
import InputText from '../../../components/inputComponents/InputText';

const ExpertConsult = () => {
  const store = useContext(GlobalContext);
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const gridRef = useRef(null);
  const [valueObj, setValueObj] = useState(null);
  const navigate = useNavigate();
  const [selectBoxData, setSelectBoxData] = useState([]);

  let gridId = '';

  if (store.store?.authrtId === 'EX') {
    gridId = 'cnslt_aplyList_exprt';
  } else {
    gridId = 'cnslt_aplyList_user';
  }

  const controller = useMemo(() => {
    return new ExpertConsultController(
      store,
      modalService,
      validateService,
      [gridRef],
      {
        valueObj,
        setValueObj,
      },
      { selectBoxData, setSelectBoxData },
      navigate
    );
  }, [store, modalService, validateService, valueObj, setValueObj, navigate]);

  const onChange = (model, value) => {
    const temp = { ...valueObj };
    temp[model] = value;
    setValueObj(temp);
  };

  const handleSelect = e => {
    onChange('processStatus', e.target.value);
  };

  useEffect(() => {
    document.title = '전문가 컨설팅 목록';
    controller.fnSearch().then();
    controller.fnGetStatusList();
  }, []);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">전문가 컨설팅 목록</h2>
      </div>
      <div id="search-box" className="section">
        <div className="section__body">
          <div className="sch-option">
            <dl className="sch-option__item">
              <dt>
                <label>요청자</label>
              </dt>
              <dd>
                <div className="input__wrap" style={{ width: '180px' }}>
                  <InputText
                    id="input_picNm"
                    model="picNm"
                    value={controller.valueObj.picNm}
                    isRequired={true}
                    isReadonly={store.store?.authrtId != 'EX'}
                    phValue={'요청자'}
                    changeEvt={(model, value) => {
                      controller.valueObjChange(model, value);
                    }}
                    blurEvt={() => {}}
                  />
                </div>
              </dd>
            </dl>
            <dl className="sch-option__item">
              <dt>
                <label>공정명</label>
              </dt>
              <dd>
                <div className="input__wrap" style={{ width: '180px' }}>
                  <InputText
                    id="input_taskNm"
                    model="taskNm"
                    value={controller.valueObj.taskNm}
                    isRequired={true}
                    isReadonly={false}
                    phValue={'공정명'}
                    changeEvt={(model, value) => {
                      controller.valueObjChange(model, value);
                    }}
                    blurEvt={() => {}}
                  />
                </div>
              </dd>
            </dl>
            <dl className="sch-option__item">
              <dt>상태</dt>
              <dd>
                <div className="input__select">
                  <select
                    onChange={handleSelect}
                    className="form-select sm"
                    aria-label="상태"
                  >
                    <option value="">전체</option>
                    {store.store?.authrtId === 'EX' ? (
                      <option value="EXPRT05">신청대기</option>
                    ) : (
                      <option value="EXPRT05">신청전</option>
                    )}
                    {selectBoxData.map((el, index) => (
                      <option key={el.seq} value={el.comCd}>
                        {el.comCdNm}
                      </option>
                    ))}
                  </select>
                </div>
              </dd>
            </dl>
          </div>
          <div className="btn-group">
            <button
              type="button"
              className="btn sm"
              onClick={() => controller.fnSearch()}
            >
              검색
            </button>
          </div>
        </div>
      </div>
      <div className="section section-table">
        <GbitGrid
          ref={gridRef}
          id={gridId}
          modalService={modalService}
          headerClick={controller.gridHeaderClick}
          cellDblClick={controller.gridCellDblClick}
          cellClick={controller.gridCellClick}
          caption="전문가 컨설팅 목록의 No, 요청자, 공정명, 전문가, 요청일자, 시작일자, 완료일자, 상태의 정보를 나타내는 표입니다."
        />
      </div>
    </>
  );
};

export default ExpertConsult;
